import { takeLatest, all } from "redux-saga/effects";
import HttpService from "../../../services/HttpService";

// eslint-disable-next-line
export function* setDataLogin({ payload }) {
	let { investor, multiBroker, billingStatus } = payload;
	investor["type"] = "FREE";
	if (localStorage.getItem("CLIENT_AUTH")) {
		localStorage.removeItem("CLIENT_AUTH");
	}
	sessionStorage.setItem("CLIENT_AUTH", JSON.stringify(investor));
	sessionStorage.setItem("HAS_MULTIBROKER", multiBroker.length);
	sessionStorage.setItem("TOKEN", investor.token);
	sessionStorage.setItem("PACK", JSON.stringify(billingStatus));
	sessionStorage.setItem("IDKEY", investor.id_investor.toString());
	sessionStorage.setItem("USING_REACT_ONBOARD", JSON.stringify(payload));
}

function* verifyHealth({ payload }) {
	try {
		let response = yield HttpService.verifyHealth();
		if (!response || !response.success) {
			throw response;
		}
	} catch (e) {
		console.error(e);
	}
}

export default all([
	takeLatest("@sessionStorage/SET_DATA_LOGIN_REQUEST", setDataLogin),
	takeLatest("@sessionStorage/VERIFY_HEALTH_CHECK_REQUEST", verifyHealth),
]);
